import React from 'react';

const ChatPerson = ({ name,data, type,selectedConversation, onClick }: {data:any; name: any; type: any; selectedConversation:any; onClick: () => void }) => {
  return (
    <div  className={`flex h-[100px] ${data.sid === selectedConversation?.sid?"bg-black":'bg-white'}  items-center p-3 border border-[#E5E3E3] rounded-[18px] cursor-pointer`} onClick={onClick}>
      <div className="bg-gray-400 h-[50px] w-[50px] rounded-full"></div>
      <div className="ml-5">
        <div className={`font-semibold ${data.sid === selectedConversation?.sid?"text-white":'text-black'}`}>{name}</div>
        <div className="text-gray-500">{type}</div>
      </div>
    </div>
  );
};

export default ChatPerson;
